
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { useTranslation } from "react-i18next";
import { ActivityResponse } from "@/types/activity";
import Hey from "@/lib/hey-utils";
import { trackTripCardAction } from "@/utils/analytics";

export const useActivitiesData = (tripId: string, destinationName: string) => {
  const [showActivities, setShowActivities] = useState(false);
  const [activitiesData, setActivitiesData] = useState<ActivityResponse | null>(null);
  const { toast } = useToast();
  const { t } = useTranslation();

  const handleActivitiesClick = async () => {
    try {
      trackTripCardAction("activities", tripId, destinationName);
      console.debug('================================================');
      console.debug('🕺 STARTING ACTIVITIES DATA FETCH');
      console.debug('📍 Trip ID:', tripId);
      try {
        const response = await Hey.HeyUtils.getInstance().getActivities(tripId, {nbResults: 30}, "discover");
        console.debug('🥳 activities data fetched successfully:', response);
        if (response && response.results && Array.isArray(response.results)) {
          console.debug('Processing activities data:', response.results);
          console.debug('TrackingId from response:', response.trackingId);
          
          response.results.forEach((activity, index) => {
            console.debug(`Activity ${index} (${activity.name}) URL details:`, {
              url: activity.url,
              urlParts: activity.url?.split('/') || [],
              trackingIdInUrl: activity.url?.includes(response.trackingId) ? 'YES' : 'NO'
            });
          });
          
          setActivitiesData(response);
          if (response.results.length === 0) {
            toast({
              description: "No activities found for this destination"
            });
          } else {
            setShowActivities(true);
          }
        } else {
          throw new Error('Invalid activities data format');
        }
      } catch (error) {
        console.error('❌ Error calling activities API:', error);
        toast({
          variant: "destructive",
          description: "Failed to fetch activities data"
        });
      }
    } catch (error) {
      console.error('General error in activities handling:', error);
      toast({
        variant: "destructive",
        description: "An error occurred while fetching activities data"
      });
    }
  };

  return {
    showActivities,
    setShowActivities,
    activitiesData,
    handleActivitiesClick
  };
};
